// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__x3vhg","rootSmall":"AddTileButton_rootSmall__bXnzh"};